/*
 * Prinsert – Brettspiel-Filter fuer Kollektionsseiten
 * Liest das Produkt-Metafeld custom.brettspiel (data-brettspiel am Grid-Item),
 * baut daraus eine Checkbox-Liste im Dawn-Filter-Markup (Desktop-Seitenleiste + Mobil-Drawer)
 * und blendet Produkte clientseitig aus. Auswahl steht als ?spiel=slug1,slug2 in der URL.
 */
(function () {
  'use strict';
  if (window.PrinsertGameFilter) return;

  var PARAM = 'spiel';
  var LIMIT = 10;
  var cfg = null;
  var selected = new Set();
  var names = {};
  var expanded = false;
  var originals = [];
  var roots = [];

  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readUrl() {
    var value = new URLSearchParams(window.location.search).get(PARAM);
    if (!value) return;
    value.split(',').forEach(function (part) {
      var slug = slugify(part);
      if (slug) selected.add(slug);
    });
  }

  function writeUrl() {
    var url = new URL(window.location.href);
    if (selected.size) {
      url.searchParams.set(PARAM, Array.from(selected).join(','));
    } else {
      url.searchParams.delete(PARAM);
    }
    var next = url.pathname + url.search.replace(/%2C/gi, ',') + url.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) history.replaceState(history.state, '', next);
  }

  function getItems() {
    var grid = document.getElementById('product-grid');
    if (!grid) return [];
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.tagName === 'LI';
    });
  }

  function collectGames(items) {
    var map = new Map();
    items.forEach(function (li) {
      var name = (li.getAttribute('data-brettspiel') || '').trim();
      if (!name) {
        li.removeAttribute('data-game-slug');
        return;
      }
      var slug = slugify(name);
      li.setAttribute('data-game-slug', slug);
      names[slug] = name;
      var entry = map.get(slug) || { slug: slug, name: name, count: 0 };
      entry.count += 1;
      map.set(slug, entry);
    });
    var lang = document.documentElement.lang || 'de';
    return Array.from(map.values()).sort(function (a, b) {
      return a.name.localeCompare(b.name, lang, { sensitivity: 'base' });
    });
  }

  /* ---------- Produktanzahl ---------- */

  function countElements() {
    var els = [];
    ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) els.push(el);
    });
    document.querySelectorAll('.mobile-facets__count').forEach(function (el) {
      els.push(el);
    });
    return els;
  }

  function captureOriginals() {
    originals = countElements().map(function (el) {
      return { el: el, html: el.innerHTML };
    });
  }

  function updateCounts(visible, total) {
    originals.forEach(function (entry) {
      if (selected.size) {
        entry.el.textContent = cfg.countFiltered.replace('8888', visible).replace('9999', total);
      } else {
        entry.el.innerHTML = entry.html;
      }
    });
  }

  function updateEmpty(visible, total) {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.parentNode) return;
    var msg = grid.parentNode.querySelector('.game-filter-empty');
    var show = selected.size > 0 && visible === 0 && total > 0;
    if (show && !msg) {
      msg = document.createElement('p');
      msg.className = 'game-filter-empty';
      msg.textContent = cfg.empty;
      grid.parentNode.insertBefore(msg, grid);
    } else if (!show && msg) {
      msg.remove();
    }
  }

  /* ---------- Markup ---------- */

  function itemHtml(g, i, variant) {
    var id = 'GameFilter-' + variant + '-' + g.slug;
    var checked = selected.has(g.slug);
    var hide = variant === 'desktop' && !expanded && i >= LIMIT && !checked;
    var text =
      '<span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label">' +
      esc(g.name) + '</span> (' + g.count + ')</span>' +
      '<span class="visually-hidden">' + esc(g.name) + ' (' + g.count + ')</span>';
    var input =
      '<input type="checkbox" id="' + id + '" value="' + esc(g.slug) + '"' + (checked ? ' checked' : '') + '>';

    if (variant === 'mobile') {
      return (
        '<li class="mobile-facets__item list-menu__item">' +
        '<label for="' + id + '" class="facets__label mobile-facets__label' + (checked ? ' active' : '') + '">' +
        input + '<span class="mobile-facets__highlight"></span>' + cfg.icons.square + cfg.icons.check + text +
        '</label></li>'
      );
    }
    return (
      '<li class="list-menu__item facets__item"' + (hide ? ' hidden' : '') + '>' +
      '<label for="' + id + '" class="facets__label facet-checkbox' + (checked ? ' active' : '') + '">' +
      input + cfg.icons.square + '<div class="svg-wrapper">' + cfg.icons.check + '</div>' + text +
      '</label></li>'
    );
  }

  function createDesktopRoot() {
    var root = document.createElement('details');
    root.className = 'facets__disclosure-vertical game-filter game-filter--desktop';
    root.id = 'GameFilterDesktop';
    root.setAttribute('open', '');
    root.setAttribute('data-variant', 'desktop');
    root.innerHTML =
      '<summary class="facets__summary caption-large focus-offset"><div>' +
      '<span class="facets__summary-label">' + esc(cfg.label) +
      ' <span class="facets__selected hidden" data-gf-selected></span></span>' +
      cfg.icons.caret +
      '</div></summary>' +
      '<div class="parent-display facets__display-vertical">' +
      '<div class="game-filter__actions game-filter__actions--top">' +
      '<button type="button" class="game-filter__reset link underlined-link" data-gf-reset hidden>' + esc(cfg.reset) + '</button>' +
      '</div>' +
      '<fieldset class="facets-wrap parent-wrap facets-wrap-vertical">' +
      '<legend class="visually-hidden">' + esc(cfg.label) + '</legend>' +
      '<ul class="facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled" role="list" data-gf-list></ul>' +
      '</fieldset>' +
      '<div class="game-filter__actions">' +
      '<button type="button" class="button-show-more link underlined-link" data-gf-more hidden></button>' +
      '<button type="button" class="game-filter__reset link underlined-link" data-gf-reset hidden>' + esc(cfg.reset) + '</button>' +
      '</div>' +
      '</div>';
    return root;
  }

  function createMobileRoot() {
    var root = document.createElement('details');
    root.className = 'mobile-facets__details game-filter game-filter--mobile';
    root.id = 'GameFilterMobile';
    root.setAttribute('data-variant', 'mobile');
    root.innerHTML =
      '<summary class="mobile-facets__summary focus-inset"><div>' +
      '<span>' + esc(cfg.label) + ' <span class="game-filter__selected-mobile" data-gf-selected hidden></span></span>' +
      '<span class="mobile-facets__arrow">' + cfg.icons.arrow + '</span>' +
      '</div></summary>' +
      '<div class="mobile-facets__submenu gradient">' +
      '<button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">' +
      cfg.icons.arrow + '<span>' + esc(cfg.label) + '</span></button>' +
      '<ul class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled" role="list" data-gf-list></ul>' +
      '<div class="mobile-facets__footer gradient">' +
      '<div class="mobile-facets__clear-wrapper"><a href="#" role="button" class="mobile-facets__clear underlined-link" data-gf-reset>' +
      esc(cfg.clear) + '</a></div>' +
      '<button type="button" class="button button--primary" data-gf-apply>' + esc(cfg.apply) + '</button>' +
      '</div>' +
      '</div>';
    return root;
  }

  function render(games) {
    var entries = games.slice();
    selected.forEach(function (slug) {
      var present = entries.some(function (g) {
        return g.slug === slug;
      });
      if (!present) entries.push({ slug: slug, name: names[slug] || slug, count: 0 });
    });

    roots.forEach(function (root) {
      var variant = root.getAttribute('data-variant');
      // Auf Spiel-Kollektionen (nur ein Spiel) ist der Filter sinnlos -> ausblenden
      root.hidden = entries.length < 2 && selected.size === 0;

      root.querySelector('[data-gf-list]').innerHTML = entries
        .map(function (g, i) {
          return itemHtml(g, i, variant);
        })
        .join('');

      var sel = root.querySelector('[data-gf-selected]');
      sel.textContent = '(' + selected.size + ')';
      sel.hidden = selected.size === 0;
      sel.classList.toggle('hidden', selected.size === 0);

      var more = root.querySelector('[data-gf-more]');
      if (more) {
        more.hidden = entries.length <= LIMIT;
        more.innerHTML = '<span aria-hidden="true">' + (expanded ? '- ' : '+ ') + '</span>' + esc(expanded ? cfg.less : cfg.more);
      }

      if (variant === 'desktop') {
        root.querySelectorAll('[data-gf-reset]').forEach(function (reset) {
          reset.hidden = selected.size === 0;
        });
        var top = root.querySelector('.game-filter__actions--top');
        if (top) top.hidden = selected.size === 0;
      }
    });
  }

  function apply() {
    var items = getItems();
    var games = collectGames(items);
    var visible = 0;

    items.forEach(function (li) {
      var show = selected.size === 0 || selected.has(li.getAttribute('data-game-slug'));
      li.classList.toggle('game-filter-hidden', !show);
      if (show) visible += 1;
    });

    render(games);
    updateCounts(visible, items.length);
    updateEmpty(visible, items.length);
    writeUrl();
  }

  /* ---------- Events ---------- */

  function onChange(event) {
    var input = event.target;
    if (!input.matches('input[type="checkbox"]')) return;
    event.stopPropagation();
    if (input.checked) {
      selected.add(input.value);
    } else {
      selected.delete(input.value);
    }
    var id = input.id;
    apply();
    var again = document.getElementById(id);
    if (again) again.focus();
  }

  function onClick(event) {
    var more = event.target.closest('[data-gf-more]');
    var reset = event.target.closest('[data-gf-reset]');
    var applyBtn = event.target.closest('[data-gf-apply]');
    if (applyBtn) {
      // Drawer schliessen wie Dawns "Anwenden"-Button
      var wrapper = applyBtn.closest('.mobile-facets__wrapper');
      if (wrapper) wrapper.querySelector('summary').click();
      return;
    }
    if (!more && !reset) return;
    event.preventDefault();
    event.stopPropagation();
    if (more) expanded = !expanded;
    if (reset) selected.clear();
    apply();
  }

  function wire(root) {
    // Eingaben nicht an Shopifys Filterformular weiterreichen (das wuerde neu laden)
    root.addEventListener('input', function (e) {
      e.stopPropagation();
    });
    root.addEventListener('change', onChange);
    root.addEventListener('click', onClick);
  }

  function init() {
    var cfgEl = document.getElementById('GameFilterConfig');
    if (!cfgEl) return;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }

    readUrl();

    var desktop = document.querySelector('#FacetFiltersForm.facets__form-vertical #FacetsWrapperDesktop');
    if (desktop) {
      var rootDesktop = createDesktopRoot();
      var pills = desktop.querySelector('.active-facets-desktop');
      if (pills) {
        pills.after(rootDesktop);
      } else {
        desktop.prepend(rootDesktop);
      }
      wire(rootDesktop);
      roots.push(rootDesktop);
    }

    var mobile = document.getElementById('FacetsWrapperMobile');
    if (mobile) {
      var rootMobile = createMobileRoot();
      mobile.prepend(rootMobile);
      wire(rootMobile);
      var drawer = mobile.closest('menu-drawer');
      if (drawer && typeof drawer.onSummaryClick === 'function') {
        rootMobile.querySelector('summary').addEventListener('click', drawer.onSummaryClick.bind(drawer));
        rootMobile
          .querySelector('.mobile-facets__close-button')
          .addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
      }
      roots.push(rootMobile);
    }

    if (!roots.length) return;

    captureOriginals();
    apply();

    // Preisfilter/Sortierung laden das Raster per AJAX neu -> Auswahl erneut anwenden
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function () {
        captureOriginals();
        apply();
      }).observe(container, { childList: true });
    }

    // "Alle entfernen" setzt auch den Brettspiel-Filter zurueck
    document.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest('.active-facets__button-remove') ||
          event.target.closest('#FacetsWrapperMobile > .mobile-facets__footer .mobile-facets__clear')
        ) {
          selected.clear();
          apply();
        }
      },
      true
    );
  }

  window.PrinsertGameFilter = { apply: apply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
